// Leerer Warenkorb (snippets/fk-cart-empty.liquid): lädt die Produktreihe über die Section Rendering API
// (sections/fk-cart-empty-products.liquid) und setzt sie in die Liste. Horizon rendert den leeren Zustand aus
// einem <template>, sobald der Warenkorb leer wird – das Element verbindet sich dann erneut und lädt (aus dem
// Sitzungsspeicher, 10 Minuten).

const TTL = 10 * 60 * 1000;

class FkCartEmpty extends HTMLElement {
  connectedCallback() {
    this.load().catch(() => this.querySelector('[data-list]')?.replaceChildren());
  }

  async load() {
    const list = this.querySelector('[data-list]');
    const src = this.dataset.src;
    if (!list || !src) return;
    const key = `fk-cart-empty:${src}`;
    let html = null;
    try {
      const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < TTL) html = cached.html;
    } catch {
      /* ohne Cache */
    }
    if (!html) {
      const res = await fetch(src, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      html = doc.querySelector('.shopify-section')?.innerHTML?.trim() || '';
      try {
        sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), html }));
      } catch {
        /* ignorieren */
      }
    }
    if (!this.isConnected) return;
    list.innerHTML = html;
    list.removeAttribute('aria-busy');
    this.toggleAttribute('data-empty', !html);
  }
}

if (!customElements.get('fk-cart-empty')) customElements.define('fk-cart-empty', FkCartEmpty);
